import { Injectable } from '@angular/core';
import { GENERATE_IA_CONTENT_PAYLOAD } from '@app/_models/entity-ia-content/entity-ia-content.model';
import { ApiService } from '@app/_services/api.service';
import { CommomHeaders } from '@app/_shared/httpHeaders/CommonHeaders';

@Injectable({
    providedIn: 'root',
})
export class EntityIaContentService {
    constructor(private api: ApiService, private headers: CommomHeaders) {}

    generateIaContent(payload: GENERATE_IA_CONTENT_PAYLOAD) {
        return this.api.postFz(`/api/v1/back/editor/ai/content`, payload, this.headers.getAuthHeaders());
    }
}
